/**
 * group-users-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { IncomingMessage } from "../general/";
import { MessageTag } from "../message-tag";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";

export interface UserLoginData
{
	recordId : number;
	login : string;
	name: string;
}

@validateFor(MessageTag.RSP_GROUP_USERS)
export class GroupUsersResponse extends IncomingMessage
{
	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.RSP_GROUP_USERS;
	public static tag : MessageTag = MessageTag.RSP_GROUP_USERS;

	@validateAs({array: "object"})
	public resultSet : UserLoginData[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/group-users-response.ts